import EmailSignature from '@/components/organisms/EmailSignature/EmailSignature';
import { Separator } from "@/components/ui/separator"


export function App() {
    return (
        <div>
    
        <EmailSignature
            name="Jorge Figueira"
            position="Director"
            phone="+1 (786) 508-3790"
            email="jfigueira@basciano.io"
            address="323 Sunny Isles Blvd, SUITE 700, Sunny Isles Beach, FL 33160"
            website="https://www.basciano.io"
            socialMedia={[
              { platform: 'LinkedIn', url: 'https://www.linkedin.com/company/basciano-trading-corporation/' }
            ]}
          />
        <Separator />
        <EmailSignature
            name="Alberto Tarafa"
            position="Investor"
            phone=""
            email="atarafa@basciano.io"
            address="323 Sunny Isles Blvd, SUITE 700, Sunny Isles Beach, FL 33160"
            website="https://www.basciano.io"
            socialMedia={[
              { platform: 'LinkedIn', url: 'https://www.linkedin.com/company/basciano-trading-corporation/' }
          ]}
        />
        <Separator />
        <EmailSignature
            name="Maria Altuna"
            position="General Manager"
            phone="+1 (920) 282-0850"
            email="maltuna@basciano.io"
            address="323 Sunny Isles Blvd, SUITE 700, Sunny Isles Beach, FL 33160"
            website="https://www.basciano.io"
            socialMedia={[
              { platform: 'LinkedIn', url: 'https://www.linkedin.com/company/basciano-trading-corporation/' }
            ]}
          />
          <Separator />
        <EmailSignature
            name="Jesus Altuna"
            position="Treasury Manager"
            phone=""
            email="jaltun@basciano.io"
            address="323 Sunny Isles Blvd, SUITE 700, Sunny Isles Beach, FL 33160"
            website="https://www.basciano.io"
            socialMedia={[
              { platform: 'LinkedIn', url: 'https://www.linkedin.com/company/basciano-trading-corporation/' }
            ]}
          />
          <Separator />
        <EmailSignature
            name="Andrea Parra"
            position="Treasury Coordinator"
            phone=""
            email="aparra@basciano.io"
            address="323 Sunny Isles Blvd, SUITE 700, Sunny Isles Beach, FL 33160"
            website="https://www.basciano.io"
            socialMedia={[
              { platform: 'LinkedIn', url: 'https://www.linkedin.com/company/basciano-trading-corporation/' }
            ]}
          />
          <Separator />
          <EmailSignature
            name="Customer service"
            position="Customer Support Team"
            phone=""
            email="aparra@basciano.io"
            address="323 Sunny Isles Blvd, SUITE 700, Sunny Isles Beach, FL 33160"
            website="https://www.basciano.io"
            socialMedia={[
              { platform: 'LinkedIn', url: 'https://www.linkedin.com/company/basciano-trading-corporation/' }
            ]}
          />
          <Separator />
        <EmailSignature
            name="Maria Elena Machado"
            position="Business Consultant"
            phone="+1 (829) 749-4840"
            email="melena@basciano.io"
            address="323 Sunny Isles Blvd, SUITE 700, Sunny Isles Beach, FL 33160"
            website="https://www.basciano.io"
            socialMedia={[
              { platform: 'LinkedIn', url: 'https://www.linkedin.com/company/basciano-trading-corporation/' }
            ]}
          />
          <Separator />
        <EmailSignature
            name="Rowena Dulanto"
            position="Accounting Manager"
            phone=""
            email="	rdulanto@basciano.io"
            address="323 Sunny Isles Blvd, SUITE 700, Sunny Isles Beach, FL 33160"
            website="https://www.basciano.io"
            socialMedia={[
              { platform: 'LinkedIn', url: 'https://www.linkedin.com/company/basciano-trading-corporation/' }
            ]}
          />
          <Separator />
        <EmailSignature
            name="Dheymarit Skarlet Perez"
            position="Compliance Coordinator"
            phone=""
            email="dperez@basciano.io"
            address="323 Sunny Isles Blvd, SUITE 700, Sunny Isles Beach, FL 33160"
            website="https://www.basciano.io"
            socialMedia={[
              { platform: 'LinkedIn', url: 'https://www.linkedin.com/company/basciano-trading-corporation/' }
            ]}
          />
          <Separator />
        <EmailSignature
            name="Yorlis Silva"
            position="Accounting analyst"
            phone=""
            email="ysilva@basciano.io"
            address="323 Sunny Isles Blvd, SUITE 700, Sunny Isles Beach, FL 33160"
            website="https://www.basciano.io"
            socialMedia={[
              { platform: 'LinkedIn', url: 'https://www.linkedin.com/company/basciano-trading-corporation/' }
            ]}
          />
        </div>
      );
}

export default App;